// Modular sections that can be included when publishing an event report to
// DigWatch. The base "sessions" info is always sent.
export const REPORT_SECTIONS = [
  { key: 'include_analytics', label: 'Analytics', description: 'Statistics, prominent sessions, fastest speakers and keyword analysis.' },
  { key: 'include_graph', label: 'Knowledge graph', description: 'Interactive knowledge graph link.' },
  { key: 'include_chatbot', label: 'Chatbot', description: 'AI chatbot iframe link.' },
  { key: 'include_qa', label: 'Q&A', description: 'Question & answer analysis section.' },
];

export const DEFAULT_SECTIONS = {
  include_analytics: true,
  include_graph: true,
  include_chatbot: true,
  include_qa: true,
};

export const DESTINATION_INFO = {
  faicon: {
    name: 'FAICON',
    description: 'Your report will be published to the FAICON platform where it can be accessed by authorized users.',
  },
  wordpress: {
    name: 'WordPress (DigWatch)',
    description: 'Your report will be published to WordPress (DigWatch) where it will be publicly accessible.',
  },
};

export const DIGWATCH_API_VERSION_INFO = {
  production: {
    label: 'Production (v4 / v2)',
    description: 'Current stable DigWatch routes for session and event reports.',
  },
  v5: {
    label: 'Test (v5)',
    description: 'v5 WordPress REST routes — session reports and event analytics.',
  },
  v6: {
    label: 'Test (v6)',
    description: 'v6 event analytics route. Session reports still go to the v5 session endpoint.',
  },
};
